module.exports = __webpack_public_path__ + "static/media/Note-Click-Enter-Textures-Click_in_00028.466f3d49.png";